module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-GIS1.b50ba36091371b55d8940d5d6f2f7c17.avif";